import { NoCamera, NoMicrophone } from '@myinterview/component-library';
import React from 'react';

export const NoCameraMic:React.FC = () => (
  <div className="myinterview-widget-icons__no-camera-mic">
    <div className="myinterview-widget-icons__no-camera-mic__camera">
      <NoCamera />
    </div>
    <div className="myinterview-widget-icons__no-camera-mic__mic">
      <NoMicrophone />
    </div>
  </div>
);
